




























import {ref, reactive, computed, defineComponent, PropType} from '@vue/composition-api'
import {AnyParam, isAnimatedParam} from '@/params'
import ParamAutokeyIcon from './ParamAutokeyIcon.vue'
import ParamKeyframeIcon from './ParamKeyframeIcon.vue'
import DraggableNumberInput from './DraggableNumberInput.vue'

export default defineComponent({
  name: 'VectorParam',
  components: {
    DraggableNumberInput, ParamAutokeyIcon, ParamKeyframeIcon
  },
  props: {
    param: {
      type: Object as PropType<AnyParam>,
      required: true
    }
  },

  setup(props, context) {

    function setParam(val: number, index: 0) {
      const tmp = [...props.param.value as number[]] // clone, otherwise we'd set the prop val itself
      tmp[index] = val
      context.emit('input', tmp)
    }

    function toggleAutokey() {
      context.emit('toggleAutokey')
      context.emit('startDrag')     // not really a drag, but this selects the param.
    }
    function toggleKeyframe() {
      context.emit('toggleKeyframe')
      context.emit('startDrag')     // not really a drag, but this selects the param.
    }

    return {toggleAutokey, toggleKeyframe, setParam}
  }
})
